/* section-video-testimonials.js — secțiunea „Apreciați de cei care contează” (Home v2, 2026-09-21).
   Două lucruri, ambele legate prin data-*:
   1. Playerul modal <dialog> (click / Enter / Space pe un card → clipul cu sunet și comenzi) —
      comportamentul de dinainte, neschimbat.
   2. Rândul de carduri: derulare nativă cu scroll-snap (CSS); de aici vin doar săgețile, punctele
      de paginare, tragerea cu mausul pe desktop și pauza clipurilor ieșite din ecran.
   Clipurile din carduri rămân cele lazy din snippets/video.liquid (DL.lazyVideo din theme.js le
   pune src-ul când intră în ecran; mute, în buclă). Rândul NU mai e marquee. */
(function () {
  'use strict';

  /* ── logică pură (testată în test/unit/home-video-testimonials.test.mjs) ───────────────── */

  // Pozițiile de derulare la care se poate opri rândul: marginea stângă a fiecărui card cât timp
  // încape în cursa maximă, plus capătul cursei (ultimele carduri nu ajung niciodată la stânga).
  function stops(offsets, maxScroll) {
    var out = [];
    var max = Math.max(0, Math.round(maxScroll));
    for (var i = 0; i < offsets.length; i++) {
      var x = Math.max(0, Math.round(offsets[i]));
      if (x >= max - 1) break;
      if (!out.length || x > out[out.length - 1]) out.push(x);
    }
    if (!out.length || max > out[out.length - 1]) out.push(max);
    return out;
  }

  function nearest(list, x) {
    var best = 0;
    for (var i = 1; i < list.length; i++) {
      if (Math.abs(list[i] - x) < Math.abs(list[best] - x)) best = i;
    }
    return best;
  }

  window.DLVideoTestimonials = { stops: stops, nearest: nearest };

  /* ── helperi DOM ───────────────────────────────────────────────────────────────────────── */

  function findSrc(card) {
    var v = card.querySelector('video');
    if (!v) return '';
    if (v.dataset && v.dataset.src) return v.dataset.src;
    var source = v.querySelector('source');
    if (source && source.src) return source.src;
    return v.currentSrc || v.src || '';
  }

  function textOf(card, selector) {
    var el = card.querySelector(selector);
    return el ? el.textContent : '';
  }

  function mq(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  function onDestroy(node, fn) {
    if (window.DL && typeof window.DL.onDestroy === 'function') window.DL.onDestroy(node, fn);
  }

  /* ── rândul de carduri ─────────────────────────────────────────────────────────────────── */

  function initRail(section, state) {
    var rail = section.querySelector('[data-dl-vt-rail]');
    var track = rail && rail.querySelector('[data-dl-vt-track]');
    if (!track) return;
    var nav = rail.querySelector('[data-dl-vt-nav]');
    var prev = rail.querySelector('[data-dl-vt-prev]');
    var next = rail.querySelector('[data-dl-vt-next]');
    var dotsBox = rail.querySelector('[data-dl-vt-dots]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-dl-vt-slide]'));
    var reduced = mq('(prefers-reduced-motion: reduce)');
    var list = [0];
    var current = -1;

    function go(i) {
      i = Math.max(0, Math.min(list.length - 1, i));
      track.scrollTo({ left: list[i], behavior: reduced ? 'auto' : 'smooth' });
    }

    function paint() {
      var i = nearest(list, track.scrollLeft);
      if (i === current) return;
      current = i;
      if (dotsBox) {
        Array.prototype.forEach.call(dotsBox.children, function (d, k) {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= list.length - 1;
    }

    function measure() {
      if (!slides.length) return;
      var first = slides[0].offsetLeft;
      var offsets = slides.map(function (s) { return s.offsetLeft - first; });
      list = stops(offsets, track.scrollWidth - track.clientWidth);
      if (nav) nav.hidden = list.length < 2;
      if (dotsBox && dotsBox.children.length !== list.length) {
        dotsBox.textContent = '';
        list.forEach(function (_, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dl-trusted-dot';
          b.setAttribute('aria-label', 'Mergi la grupul ' + (k + 1) + ' din ' + list.length);
          b.addEventListener('click', function () { go(k); });
          dotsBox.appendChild(b);
        });
      }
      current = -1;
      paint();
    }

    if (prev) prev.addEventListener('click', function () { go(nearest(list, track.scrollLeft) - 1); });
    if (next) next.addEventListener('click', function () { go(nearest(list, track.scrollLeft) + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; paint(); });
    }, { passive: true });

    var resizeTimer = 0;
    function onResize() { clearTimeout(resizeTimer); resizeTimer = setTimeout(measure, 120); }
    window.addEventListener('resize', onResize);
    onDestroy(section, function () { clearTimeout(resizeTimer); window.removeEventListener('resize', onResize); });

    // Tragere cu mausul (desktop). Atingerea rămâne derulare nativă, deci doar pointerType mouse.
    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false };
    });
    function onMove(e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      if (!drag.moved) { drag.moved = true; track.classList.add('is-dragging'); }
      track.scrollLeft = drag.left - dx;
      e.preventDefault();
    }
    function onUp() {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      if (!moved) return;
      // clicul care urmează unei trageri nu are voie să deschidă playerul
      state.suppressClickUntil = Date.now() + 350;
      var target = nearest(list, track.scrollLeft);
      track.classList.remove('is-dragging');
      go(target);
    }
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    onDestroy(section, function () {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
    });

    measure();
    // fonturile / CSS-ul pot sosi după primul calcul
    window.addEventListener('load', measure, { once: true });
  }

  /* ── clipurile din carduri: pauză în afara ecranului, fără mișcare la reduced-motion ───── */

  function initCardVideos(section, state) {
    var videos = Array.prototype.slice.call(section.querySelectorAll('[data-dl-video-card] video'));
    if (!videos.length) return;
    var reduced = mq('(prefers-reduced-motion: reduce)');

    if (reduced) {
      // Clipul se încarcă (primul cadru ține loc de poster), dar nu rulează.
      section.addEventListener('playing', function (e) {
        var v = e.target;
        if (v && v.closest && v.closest('[data-dl-video-card]')) v.pause();
      }, true);
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        v._dlVtVisible = en.isIntersecting;
        if (!en.isIntersecting) { v.pause(); return; }
        if (state.modalOpen || !v.getAttribute('src')) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }, { threshold: 0.2 });
    videos.forEach(function (v) { io.observe(v); });
    onDestroy(section, function () { io.disconnect(); });

    state.pauseCards = function () { videos.forEach(function (v) { v.pause(); }); };
    state.resumeCards = function () {
      videos.forEach(function (v) {
        if (!v._dlVtVisible || !v.getAttribute('src')) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    };
  }

  /* ── playerul modal ────────────────────────────────────────────────────────────────────── */

  function initSection(section) {
    section.dataset.bound = '1';
    var state = { suppressClickUntil: 0, modalOpen: false, pauseCards: null, resumeCards: null };

    initRail(section, state);
    initCardVideos(section, state);

    var dialog = section.querySelector('[data-dl-video-modal]');
    var player = dialog && dialog.querySelector('[data-dl-video-modal-player]');
    if (!dialog || !player) return;
    var nameEl = dialog.querySelector('[data-dl-video-modal-name]');
    var subEl = dialog.querySelector('[data-dl-video-modal-subtitle]');
    var closeBtn = dialog.querySelector('[data-dl-video-modal-close]');

    function close() {
      if (dialog.open) dialog.close();
      player.pause();
      player.removeAttribute('src');
      player.load();
      if (state.modalOpen) {
        state.modalOpen = false;
        if (state.resumeCards) state.resumeCards();
      }
    }

    function openFromCard(card) {
      var src = findSrc(card);
      if (!src) return;
      state.modalOpen = true;
      if (state.pauseCards) state.pauseCards();
      player.src = src;
      if (nameEl) nameEl.textContent = textOf(card, '.dl-trusted-card-name');
      if (subEl) {
        var parts = [textOf(card, '.dl-trusted-card-role'), textOf(card, '.dl-trusted-card-chip')];
        subEl.textContent = parts.filter(Boolean).join(' · ');
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      var p = player.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocat — comenzile rămân disponibile */ });
    }

    // Ascultători delegați: o pereche pentru tot rândul, merg și pentru blocurile adăugate din
    // editorul de teme.
    section.addEventListener('click', function (e) {
      if (Date.now() < state.suppressClickUntil) return;
      var card = e.target.closest('[data-dl-video-card]');
      if (card) openFromCard(card);
    });
    section.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('[data-dl-video-card]');
      if (!card) return;
      e.preventDefault();
      openFromCard(card);
    });

    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-dl-video-cards]:not([data-bound])').forEach(initSection);
  }

  // Înregistrare prin DL.use, cu rezervă pe DOMContentLoaded dacă theme.js nu s-a încărcat.
  // Verificarea se face ÎN callback, nu la parsare: layout/theme.liquid încarcă scripturile de
  // secțiune înaintea lui theme.js (ambele defer), deci la parsare `window.DL` încă nu există.
  function register() {
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(init);
    else init(document);
  }
  if (document.readyState === 'complete') register();
  else document.addEventListener('DOMContentLoaded', register);
})();
